import { Modal } from 'rsuite';
import styled from 'styled-components';

const FluidModal = styled(Modal)`
  max-width: 90%;
`;

export default FluidModal;
